// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#goalChange .ClickSelect__control {
  min-width: 300px;
}`, "",{"version":3,"sources":["webpack://./src/views/UserManagement/Projects/BulkUpload/style.scss"],"names":[],"mappings":"AACE;EACE,gBAAA;AAAJ","sourcesContent":["#goalChange {\n  .ClickSelect__control {\n    min-width: 300px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
